import { create } from "zustand"

/** Hardcoded boost for the online pill in TopBar. */
const ONLINE_COUNT_DISPLAY_OFFSET = 2

interface OnlineStoreState {
  currentOnline: number | null
  setCurrentOnline: (count: number | null) => void
}

export const useOnlineStore = create<OnlineStoreState>((set) => ({
  currentOnline: null,
  setCurrentOnline: (count) =>
    set({
      currentOnline:
        count == null ? null : count + ONLINE_COUNT_DISPLAY_OFFSET,
    }),
}))
